export const propertyImages = {
      "Vegetarian": "/assets/media/my/vegitarian_icon1.png",
      "Vegan": "/assets/media/my/vegan.png",
      "Gluten Free": "/assets/media/my/gluten-free.png",
      "Lactose Free": "/assets/media/my/lactose-free.png",
      "Spicy": "/assets/media/my/spicy.png",
      "Contains Alcohol": "/assets/media/my/contains_alcohol.png",
      "Alcohol Free": "/assets/media/my/alcoholno.png",
      "Chef’s Special": "/assets/media/my/chef-hat.png",
    };